import { FilterSectionContainterStyled } from '@hellodarwin/core/lib/components/grants/funding-explorer/filter/styles';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css } from 'styled-components';
export const getPaddingInlineSize = (isAdmin, isTablet, theme) => {
    if (isTablet) {
        return theme.spacing.md;
    }
    return isAdmin ? theme.spacing.xl : theme.spacing.xxl;
};
export const IconContent = styled.div `
  position: absolute;
  top: ${(props) => (props.$iconTop ? `${props.$iconTop}px` : 0)};
  width: fit-content;
  height: fit-content;

  ${(props) => props.$side === 'right'
    ? css `
          right: ${typeof props.$iconMargin === 'number'
        ? `${props.$iconMargin}px`
        : props.$iconMargin};
        `
    : css `
          left: ${typeof props.$iconMargin === 'number'
        ? `${props.$iconMargin}px`
        : props.$iconMargin}px;
        `}

  svg {
    overflow: visible;
    ${(props) => props.$iconColor &&
    css `
        color: ${props.$iconColor};
      `}
    ${(props) => props.$iconWidth &&
    css `
        width: ${props.$iconWidth}px;
      `}
    ${(props) => props.$iconHeight &&
    css `
        height: ${props.$iconHeight}px;
      `}
    ${(props) => {
    if (props.$inversed) {
        return props.$iconRotate
            ? css `
              transform: rotate(${props.$iconRotate}deg) scaleY(-1);
            `
            : css `
              transform: scaleY(-1);
            `;
    }
    else {
        return props.$iconRotate
            ? css `
              transform: rotate(${props.$iconRotate}deg);
            `
            : undefined;
    }
}}
  }
`;
export const PageContentStyled = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  height: fit-content;
  gap: ${({ theme }) => theme.spacing.lg}px;
  flex: 1;
  overflow-y: auto;
  overflow-x: visible;

  ${({ $withoutPadding, $withoutPaddingHorizontal, $withoutPaddingRight, $isAdmin, theme, }) => {
    const paddingSize = getPaddingInlineSize($isAdmin, false, theme);
    const paddingSizeTablet = getPaddingInlineSize($isAdmin, true, theme);
    if ($withoutPadding) {
        return css `
        padding: 0;
        ${PageHeadingStyled} {
          padding-inline: ${paddingSize}px;
        }
        ${media.tablet `
          padding-inline: 0;
          ${PageHeadingStyled} {
            padding-inline: ${paddingSizeTablet}px;
          }
        `}
      `;
    }
    else if ($withoutPaddingHorizontal) {
        return css `
        padding-inline: 0;
        width: 100%;
        ${PageHeadingStyled} {
          padding-inline: ${paddingSize}px;
        }
        ${media.tablet `
          padding-inline: 0;
          ${PageHeadingStyled} {
            padding-inline: ${paddingSizeTablet}px;
          }
        `}
      `;
    }
    else if ($withoutPaddingRight) {
        return css `
        padding-inline-start: ${paddingSize};
        ${PageHeadingStyled} {
          padding-inline-end: ${paddingSize};
        }
        ${media.tablet `
          padding-inline-start: ${paddingSizeTablet}px;
          ${PageHeadingStyled} {
            padding-inline-end: ${paddingSizeTablet}px;
          }
        `}
      `;
    }
    else {
        return css `
        padding-inline: ${paddingSize}px;
        ${PageHeadingStyled} {
          padding-inline: 0;
        }
        ${media.tablet `
          padding-inline: ${paddingSizeTablet}px;
        `}
      `;
    }
}}

  ${({ $withoutPadding, $isAdmin, $noFooter, theme }) => {
    if (!$withoutPadding) {
        return css `
        padding-block-start: ${$isAdmin
            ? theme.spacing.md
            : theme.spacing.lg}px;
        padding-block-end: ${$noFooter ? 0 : theme.spacing.lg}px;
      `;
    }
    return '';
}}

  ${media.tablet `
    gap: ${({ theme }) => theme.spacing.xl}px;
    height: 100%;

    & > * {
      flex: none !important;
    }
  `}
`;
export const PageContainerStyled = styled.main `
  padding-left: 0;
  padding-right: 0;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  position: relative;

  ${({ $backgroundColor }) => $backgroundColor &&
    css `
      background-color: ${$backgroundColor};
    `}

  li {
    width: fit-content;
    .hd-text {
      width: fit-content;
      display: inline;
    }
  }

  ${FilterSectionContainterStyled} {
    position: absolute;
    right: 0;
    width: 100%;

    &.footer {
      bottom: 0;
    }

    &.header {
      top: 0;
    }
    ${media.tablet `
        position:sticky;
      `}
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    width: 100%;
    display: block;
    ${PageContentStyled} {
      padding-block-start: ${({ theme }) => theme.spacing.md}px;
      gap: ${({ theme }) => theme.spacing.md}px;
    }
  }
`;
export const PageBackground = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ $backgroundColor, theme }) => $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : theme.colors.background};
  overflow: hidden;
  z-index: -1;
`;
export const PageContainerWrapper = styled.div `
  width: 100%;
  background: ${({ $containerBackgroundColor }) => $containerBackgroundColor};
  position: relative;
  overflow: ${({ $overflowHidden }) => ($overflowHidden ? 'hidden' : 'auto')};
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  body.natural-scroll & {
    overflow: visible;
  }
`;
export const PageHeadingStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  position: relative;

  ${media.tablet `
    gap: ${({ theme }) => theme.spacing.md}px;
  `}
`;
